import { ScreenSizes } from '@interfaces/index';
import { useTheme } from '@mui/material';

export const useStyles = () => {
  const { breakpoints } = useTheme();

  return {
    logoWrapper: (stickToTheTop: boolean) => {
      if (stickToTheTop) {
        return {
          marginTop: '-40px',
          [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
            marginTop: '-30px',
          },
          [breakpoints.down(ScreenSizes.Tablet)]: {
            marginTop: '-20px',
          },
        };
      }
    },
    img: {
      display: 'block',
      width: '100%',
      height: 'auto',
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        width: '80%',
      },
      [breakpoints.down(ScreenSizes.Tablet)]: {
        width: '70%',
      },
      [`@media screen and (orientation:landscape)
      and (max-device-height: 760px)
      and (max-device-width: 1180px)`]: {
        width: '70%',
      },
    },
  };
};
